// Attribute definition types
export enum AttributeDefinitionType {
  BOOLEAN = "BOOLEAN",
  FLOAT = "FLOAT",
  RADIO = "RADIO",
  MEDICATION = "MEDICATION",
  MEDICATION_GROUP = "MEDICATION_GROUP",
}

export interface AttributeValueInput {
  attributeDefinitionId: number;
  isSkipped?: boolean;
  booleanAttributeValue?: boolean;
  floatAttributeValue?: number;
  radioAttributeValue?: string;
  medicationAttributeValue?: MedicationValue;
  medicationGroupAttributeValue?: MedicationGroupValue;
}

interface FuzzyDate {
  year?: number;
  month?: number;
  day?: number;
  current?: boolean;
  isBeforeX?: boolean;
}

interface MedicationInterval {
  start: FuzzyDate;
  end: FuzzyDate;
}

export interface MedicationValue {
  hasTaken: boolean;
  intervals?: MedicationInterval[];
}

export interface MedicationGroupValue {
  hasTaken: boolean;
  intervals?: MedicationInterval[];
}

export interface QuestionnaireAnswers {
  [key: string]: string | string[] | undefined;
} 